import React from 'react';
import * as R from 'ramda';
import { FieldArray } from 'formik';
// components
import { FormSectionHeader } from '../../../components';
// helpers/constants
import * as G from '../../../helpers';
import * as GC from '../../../constants';
// forms
import { Fieldset2 } from '../../../forms/formik';
// icons
import * as I from '../../../svgs';
// ui
import { Box, Flex } from '../../../ui';
// feature location
import { contactFieldSettings, getNewContactsArrayFields } from '../settings/fields';
//////////////////////////////////////////////////

const ContactRow = (props) => {
  const { fields, remove, fieldName, itemIndex, arrayLength, isReadOnlyMode } = props;

  return (
    <Flex mt={25}>
      {
        R.not(isReadOnlyMode) &&
        <Flex
          mr={10}
          cursor='pointer'
          onClick={() => remove(itemIndex)}
          title={G.getWindowLocale('titles:remove', 'Remove')}
        >
          {I.trash(G.getTheme('colors.dark.blue'))}
        </Flex>
      }
      <Fieldset2
        {...G.getFormikProps(props)}
        {...G.getArrayFormikProps(props)}
        fields={fields}
        arrayLength={arrayLength}
        arrayName={fieldName || GC.FIELD_CONTACTS}
      />
    </Flex>
  );
};

export const ContactsArray = (props) => {
  const { title, maxItems, contacts, fieldName, isReadOnlyMode, contactRowFields } = props;

  const condition = R.or(R.gte(R.length(contacts), maxItems), isReadOnlyMode);
  const fieldsSettings = R.map(R.assoc('disabled', isReadOnlyMode), R.or(contactRowFields, contactFieldSettings));

  return (
    <FieldArray
      name={fieldName || GC.FIELD_CONTACTS}
      render={(arrayHelpers) => (
        <Box>
          <FormSectionHeader
            expanded={true}
            isReadOnlyMode={isReadOnlyMode}
            title={title || G.getWindowLocale('titles:contacts', 'Contacts')}
            action={condition ? null : () => arrayHelpers.push(getNewContactsArrayFields())}
          >
            {
              G.isNotNilAndNotEmpty(contacts) &&
              <Box px={20} mb={15}>
                {
                  contacts.map((_, index) => (
                    <ContactRow
                      {...props}
                      {...arrayHelpers}
                      key={index}
                      itemIndex={index}
                      fields={fieldsSettings}
                      isReadOnlyMode={isReadOnlyMode}
                      arrayLength={R.length(contacts)}
                    />
                  ))
                }
              </Box>
            }
          </FormSectionHeader>
        </Box>
      )}
    />
  );
};
